<template lang="pug">
footer.footer
  ul.nav.justify-content-center.py-3
    li.nav-item
      a.nav-link(:href='`${linkBase}/terms`' target='_blank') {{ $t('nav.footer.termsOfUse') }}
    li.nav-item
      a.nav-link(:href='`${linkBase}/privacy`' target='_blank') {{ $t('nav.footer.privacyPolicy') }}
    li.nav-item
      a.nav-link(:href='`${linkBase}/cookie`' target='_blank') {{ $t('nav.footer.cookiePolicy') }}
</template>
<script>
import ApplicationService from '@/services/ApplicationService';

export default {
  name: 'FooterOrganisms',
  computed: {
    linkBase() {
      return ApplicationService.getAuthorizationLinkBase(this.$i18n.locale);
    },
  },
};
</script>
<style lang="stylus">
.footer
  background-color: rgba(240, 240, 240, 1)
  font-size: 0.9rem
  .nav-link
    color: rgba(1, 61, 82, 1)
    border-right: 1px solid rgba(1, 61, 82, 1)
    padding: 0 0.3rem
    font-size: 0.8rem
  .nav-item
    &:last-child
      .nav-link
        border-right: none
@media (min-width: 576px)
  .footer .nav-link
    padding: 0 1rem
    font-size: 1rem
</style>
